import { useForm } from 'react-hook-form';
import Utils from '../../../Utils';
import Modal from '../../../Components/Modal/Modal';

import styles from './CalendarPage.module.css';
import API from '../../../Utils/api';

export default function CreateRace({ user, data, closeCB, onSuccess, onFailure }) {
    const defaultTime = '09:00';
    const { register, handleSubmit } = useForm({
        defaultValues: {
            ...data,
            raceTime: defaultTime
        }
    });
    const date = Utils.dateToSimpleDateFormat(data.start);

    const onEventCreate = async ({ raceDate, raceTime, raceDistance, raceStyle, raceLocation }) => {
        try {
            // Combine date and time for raceStart
            const raceStart = new Date(`${raceDate}T${raceTime}`);
            // Add 30 minutes for raceEnd
            const raceEnd = new Date(raceStart.getTime() + 30 * 60000);

            const { data } = await API.createRace(user._id, {
                raceDate: new Date(raceDate).toUTCString(),
                raceStart: raceStart.toUTCString(),
                raceEnd: raceEnd.toUTCString(),
                raceType: raceDistance,
                raceStyle,
                raceLocation,
                status: 'Assigned'
            });
            onSuccess('Race created!', data);
        } catch (err) {
            onFailure("Couldn't create race!");
        }
    };

    return (
        <Modal
            closeCB={closeCB}
            title={'Create Race'}
            footer={
                <button className='btn btn-primary' onClick={handleSubmit(onEventCreate)}>
                    Add
                </button>
            }
        >
            <form className={styles.form}>
                <div className='form-row'>
                    <div className='form-group'>
                        <label htmlFor='raceDate'>Race Date</label>
                        <input
                            type='date'
                            {...register('raceDate', { required: true })}
                            className='form-control'
                            placeholder='Start Datetime'
                            defaultValue={date}
                            lang='en'
                        />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='raceTime'>Start Time</label>
                        <input
                            type='time'
                            {...register('raceTime', { required: true })}
                            className='form-control'
                        />
                    </div>
                </div>
                <div className='form-row'>
                    <div className='form-group'>
                        <label htmlFor='raceStyle'>Race Style</label>
                        <select className='form-control' {...register('raceStyle', { required: true })}>
                            <option value={'Freestyle'}>Freestyle</option>
                            <option value={'Backstroke'}>Backstroke</option>
                            <option value={'Breaststroke'}>Breaststroke</option>
                            <option value={'Butterfly'}>Butterfly</option>
                            <option value={'IM'}>Individual Medley</option>
                        </select>
                    </div>
                    <div className='form-group'>
                        <label htmlFor='raceDistance'>Race Distance</label>
                        <select
                            className='form-control'
                            {...register('raceDistance', { required: true })}
                        >
                            <option value={'50'}>50</option>
                            <option value={'100'}>100</option>
                            <option value={'200'}>200</option>
                            <option value={'400'}>400</option>
                            <option value={'800'}>800</option>
                            <option value={'1500'}>1500</option>
                        </select>
                    </div>
                </div>
                <div className='form-group'>
                    <label htmlFor='raceLocation'>Location</label>
                    <input
                        type='text'
                        {...register('raceLocation', { required: true })}
                        className='form-control'
                    />
                </div>
            </form>
        </Modal>
    );
}
